import { memo, useContext } from "react";

// MUI
import { Box, IconButton, Tooltip } from "@mui/material";

// Icons
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import { Context } from "./Context";
import { gettingTotalOvertime } from "utils/Timecard";
import moment from "moment";

const OvertimeCell = memo(({ params, setOpenApprove, setOpenRecant }) => {
	const regex = /auto-generated-row-null/;

	const { apiRef, periods, range1, setAmount } = useContext(Context);

	const gettingOpacity = () => {
		const period = periods.find(
			(period) => period.full_name === params?.rowNode?.groupingKey
		);

		if (period) {
			if (
				moment(period.end_date, "YYYY-MM-DD").isSameOrAfter(
					moment(range1[1], "YYYY-MM-DD")
				)
			) {
				return 0.5;
			} else {
				return 1;
			}
		} else {
			return 1;
		}
	};

	const totals = gettingTotalOvertime(params, apiRef);

	return (
		<>
			<Box
				sx={{
					width: "100%",
					display: "grid",
					placeItems: "center",
					alignItems: "center",
					alignContent: "center",
					height: "100%",
				}}
			>
				{regex.test(params?.id) ? (
					<Box sx={{ opacity: gettingOpacity() }}>
						{totals !== "0:00" ? (
							<Box
								sx={{
									color: (theme) => theme.palette.error.main,
								}}
							>
								{totals}
							</Box>
						) : (
							totals
						)}
					</Box>
				) : (
					<Box
						sx={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							placeItems: "center",
							alignContent: "center",
						}}
					>
						{params?.value?.pending_overtime.exist && (
							<Tooltip
								title={`${params?.row?.overtime?.pending_overtime?.amount}`}
							>
								<span>
									<IconButton
										disabled={
											params?.row?.open_period.open ===
											false
										}
										color="error"
										onClick={() => {
											setOpenApprove(true);
											setAmount(
												moment(
													`${params?.row?.date} ${params?.row?.overtime?.pending_overtime?.amount}`,
													"YYYY-MM-DD HH:mm"
												)
											);
										}}
									>
										<MoreTimeIcon />
									</IconButton>
								</span>
							</Tooltip>
						)}

						{params?.value?.rejected_overtime.exist && (
							<Tooltip
								title={`${params?.row?.overtime?.rejected_overtime?.amount}`}
							>
								<span>
									<IconButton
										disabled={
											params?.row?.open_period.open ===
											false
										}
										color="warning"
										onClick={() => {
											setOpenRecant(true);
											setAmount(
												moment(
													`${params?.row?.date} ${params?.row?.overtime?.rejected_overtime?.amount}`,
													"YYYY-MM-DD HH:mm"
												)
											);
										}}
									>
										<MoreTimeIcon />
									</IconButton>
								</span>
							</Tooltip>
						)}

						{params?.value?.approved_overtime.exist && (
							<Tooltip
								title={`${params?.row?.overtime?.approved_overtime?.amount}`}
							>
								<span>
									<IconButton
										disabled={
											params?.row?.open_period.open ===
											false
										}
										color="success"
										onClick={() => {
											setOpenRecant(true);
											setAmount(
												moment(
													`${params?.row?.date} ${params?.row?.overtime?.approved_overtime?.amount}`,
													"YYYY-MM-DD HH:mm"
												)
											);
										}}
									>
										<MoreTimeIcon />
									</IconButton>
								</span>
							</Tooltip>
						)}
					</Box>
				)}
			</Box>
		</>
	);
});

export { OvertimeCell };
